<template>
  <div class="Home bg-black">
    <h1 class="text-transparent fixed">Architect Serving Launceston and Devonport</h1>
    <div class="fixed w-full h-screen">
      <transition
        :key="index"
        v-for="(slide, index) in slideInfo"
        name="transHomeVideo"
      >
        <video v-if="showSlide&&currentSlide.whichVideo===index" class="video z-20" autoplay muted loop playsinline>
          <source :src="slide.videoSrc + '.webm'" type="video/webm">
          <source :src="slide.videoSrc + '.mp4'" type="video/mp4">
        </video>
      </transition>

      <div class="h-screen w-full flex flex-wrap justify-end items-between">
        <div style="height:50%;" class="w-full md:w-1/2">
        </div>
        <div class="w-full md:w-1/2 bg-black text-white flex flex-wrap pt-6 pb-6 pl-6 pr-40 md:p-10 content-start h-full">
          <div class="w-full z-10">
            <transition
              name="transHomeHeading"
            >
              <h1 v-if="showSlide" class="text-7xl lg:text-9xl hidden md:flex ml-1 absolute top-0 bottom-0 left-0 right-auto md:right-0 mt-auto mb-auto w-24 md:w-full md:ml-0 items-center justify-center">
                {{currentSlide.heading}}
                </h1>
            </transition>
            <transition
              name="transHomeHeadingMobile"
            >
              <h1 v-if="showSlide" class="flex md:hidden ml-1 absolute top-0 bottom-0 left-0 right-auto md:right-0 mt-auto mb-auto w-24 md:w-full md:ml-0 transform -rotate-90 md:rotate-0 items-center justify-center">
                {{currentSlide.heading}}
              </h1>
            </transition>
          </div>
          <div style="height:50%;" class="hidden md:block w-full">
          </div>
          <transition
            name="transHomeText"
          >
            <div
            v-if="showSlide"
            class="
              flex
              flex-wrap
              mt-0
              ml-24
              pt-0
              md:block
              md:mt-16
              md:ml-0
              md:pt-2
              z-20 w-full justify-start
              "
            >
              <p class="w-full md:w-1/2 text-sm leading-7 md:text-base md:leading-7 lg:text-xl lg:leading-9">
                {{currentSlide.text}}
              </p>
              <div class="w-64 mt-6 sm:mt-6 md:mt-8 lg:mt-6">
                <CustomButton @onClick="goToPage(currentSlide.buttonPath)">
                  {{currentSlide.buttonText}}
                </CustomButton>
              </div>
              <p
                @click="goToSlide(currentSlideIndex + 1)"
                v-if="showSlide&&currentSlideIndex!==slideInfo.length - 1"
                class="mb-3 flex ml-1 absolute bottom-0 left-0 right-auto right-0 w-full items-center justify-center cursor-pointer uppercase text-xs tracking-widest font-sansBold font-medium"
              >
                Scroll Down
              </p>
            </div>
          </transition>
        </div>
      </div>
      <div class="fixed top-0 bottom-0 mt-auto mb-auto right-0 w-64 h-64 flex items-center justify-end z-40">
        <SelecterDots :activeDot="currentSlideIndex" :numberOfDots="slideInfo.length" @onClick="goToSlide" vertical />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomButton from '@/components/elements/CustomButton.vue'
import SelecterDots from '@/components/elements/SelecterDots.vue'

export default {
  name: 'home',
  components: {
    CustomButton,
    SelecterDots
  },
  metaInfo () {
    return {
      title: 'Architecture in Devonport & Launceston | Starbox Architecture',
      meta: [
        {
          name: 'description',
          content: 'Starbox Architecture is a team of Devonport-based architects that serve individuals around Launceston. Visit us online to get started!'
        },
        {
          name: 'keywords',
          content: 'starbox,architecture,starbox architecture,tasmania,tasmanian,tasmanian architecture,tasmania architecture'
        }
      ]
    }
  },
  data () {
    return {
      lastScrollPosition: 0,
      currentScrollPosition: 0,
      showSlide: true,
      currentSlideIndex: 0,
      slideInfo: [
        {
          heading: 'TAILORED.',
          text: 'Starbox Architecture is a boutique architecture practice with a focus on creating spaces together so that the built environment can be humanised',
          whichVideo: 0,
          buttonText: 'Projects',
          buttonPath: '/projects',
          videoSrc: '/videos/Starbox Architecture - Collaborative_1'
        },
        {
          heading: 'COLLABORATIVE.',
          text: 'We do this by building relationships, sharing and discussing ideas and investing time and thought into each individual project.',
          whichVideo: 1,
          buttonText: 'Projects',
          buttonPath: '/projects',
          videoSrc: '/videos/Starbox Architecture - Dynamic_1'
        },
        {
          heading: 'DYNAMIC.',
          text: 'To create a built form that is physically beautiful and enriches the lives of its occupants pragmatically and aesthetically.',
          whichVideo: 2,
          buttonText: 'Projects',
          buttonPath: '/projects',
          videoSrc: '/videos/Starbox Architecture - Tailored 2'
        }
      ]
    }
  },
  computed: {
    currentSlide () {
      return this.slideInfo[this.currentSlideIndex]
    }
  },
  methods: {
    onScroll () {
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      this.currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (this.currentScrollPosition < 0) {
        return
      }

      var scrollDifference = this.currentScrollPosition - this.lastScrollPosition

      if (this.showSlide) {
        if (scrollDifference > 0) {
          // Scrolling UP
          if (this.currentSlideIndex < (this.slideInfo.length - 1)) {
            this.goToSlide(this.currentSlideIndex + 1)
            // this.currentSlideIndex++
            // this.showSlide = false
            // setTimeout(() => this.showSlideAfter(), 2000)
          }
        } else if (scrollDifference < 0) {
          // Scrolling DOWN
          if (this.currentSlideIndex > 0) {
            this.goToSlide(this.currentSlideIndex - 1)
            // this.currentSlideIndex--
            // this.showSlide = false
            // setTimeout(() => this.showSlideAfter(), 2000)
          }
        }
      }

      this.lastScrollPosition = this.currentScrollPosition
    },
    showSlideAfter () {
      this.showSlide = true
      this.lastScrollPosition = this.currentScrollPosition
    },
    goToPage (path) {
      this.$router.replace(path)
    },
    goToSlide (slideIndex) {
      this.currentSlideIndex = slideIndex
      this.showSlide = false
      setTimeout(() => this.showSlideAfter(), 2000)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style lang="scss">
  $sm: '640px';
  $md: '768px';
  $lg: '1024px';
  $xl: '1280px';
  $xxl: '1920px';

  .Home {
    height: 10000px;

    .video {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0%;
      width: 100%;
      height: 50%;
      object-fit: cover;
      z-index: -100;
    }

    @media (min-width: $sm) {
      .video {
        object-fit: cover;
      }
    }

    @media (min-width: $md) {
      .video {
        object-fit: cover;
        right: 25%;
        height: 100%;
      }
    }

    @media (min-width: $lg) {
      .video {
        object-fit: cover;
      }
    }

    @media (min-width: $xl) {
      .video {
        object-fit: contain;
      }
    }

    @media (min-width: $xxl) {
      .video {
        object-fit: contain;
      }
    }

  }
</style>
